var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Arrow = function (_a) {
    var color = _a.color, className = _a.className, props = __rest(_a, ["color", "className"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 8 14", width: "8", className: className }, props),
        React.createElement("path", { d: "m10.5585938-.68359375-5.0384522 5 5.0384522 5-1.2695313 1.25000005-6.34765625-6.25000005 6.34765625-6.25z", fill: color, fillRule: "evenodd", transform: "matrix(-1 0 0 -1 10.503906 11.128906)" })));
};
Arrow.defaultProps = {
    className: '',
    color: '#333',
};
export default Arrow;
//# sourceMappingURL=Arrow.js.map